import React, { useState, useContext } from 'react';

import { Box, Card, CardContent, Tabs, Tab } from '@material-ui/core';
import TabPanel from '../_shared/Tabs';
import VehicleDashboard from './vehicles/VehicleDashboard';
import AquisitionDashboard from './acquisitions/AcquisitionDashboard';
import SalesDashboard from './sales/SalesDashboard';
import { ApplicationContext } from '../../context/Contexts';

enum DashboardTab {
  VEHICLES = 0,
  AQUISITIONS = 1,
  SALES = 2
}

const Dashboards: React.FC = () => {
  const context = useContext(ApplicationContext);
  const [selectedTab, setSelectedTab] = useState<DashboardTab>(DashboardTab.VEHICLES);

  return (
    <div>
      <Box m={1} p={1}>
        <Card className="card-box">
          <CardContent className="card-header border-0">
            <div className="card-header--actions">
              <Tabs
                value={selectedTab}
                indicatorColor="primary"
                textColor="primary"
                variant="standard"
                onChange={(e: React.ChangeEvent<any>, newTab: number) =>
                  setSelectedTab(newTab as DashboardTab)
                }
              >
                <Tab
                  value={DashboardTab.VEHICLES}
                  className="text-capitalize"
                  label={context.translatorService.Tranlate('MENU_VEHICLES', 'Stoc vehicule')}
                />
                <Tab
                  value={DashboardTab.AQUISITIONS}
                  className="text-capitalize"
                  label={context.translatorService.Tranlate('DASHBOARD_ACQUISITION_TAB', 'Achizitii')}
                />
                <Tab
                  value={DashboardTab.SALES}
                  className="text-capitalize"
                  label={context.translatorService.Tranlate('DASHBOARD_SALES_TABLE_TITLE', 'Vanzari')}
                />
              </Tabs>
            </div>
          </CardContent>
        </Card>
      </Box>
      <div className="mt-4">
        <TabPanel value={selectedTab} index={0}>
          <VehicleDashboard />
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
          <AquisitionDashboard />
        </TabPanel>
        <TabPanel value={selectedTab} index={2}>
          <SalesDashboard />
        </TabPanel>
      </div>
    </div>
  );
};

export default Dashboards;
